import { createFileRoute } from '@tanstack/react-router';

import { HackathonsView } from '@/features/Hackathons/HackathonsView';

export const Route = createFileRoute('/admin/batches/$batchId/hackathons/')({
  component: AdminHackathonsTab,
});

export function AdminHackathonsTab() {
  const { batchId } = Route.useParams();
  return (
    <div className="p-6">
      <HackathonsView
        batchId={batchId}
        detailTo="/admin/batches/$batchId/hackathons/$hackathonId"
      />
    </div>
  );
}
